/*
* Survey
*/
export default defineNuxtPlugin(async (nuxtApp) => {
  // const { surveyPlugin } = await import('survey-vue3-ui')
  
  // nuxtApp.vueApp.use(surveyPlugin)

  // return {
  //   provide: {
  //     surveyPlugin
  //   }
  // }
})